import boardsIcon from '../../../images/boardsIcon.svg';
import standingMan from '../../../images/standing-man.svg';
import WhyTrovaItem from './WhyTrovaItem';
import {whyTrovaList} from '../../../content/whyTrovaList';
import * as Styled from './WhyTrovaStyles';
import {Col, Container, Row} from 'react-bootstrap';
import Headline from '../Headline/Headline';

const WhyTrova = () => {
  return (
    <Container fluid>
      <Row>
        <Col md={4} lg={3} className="d-lg-block d-none">
          <Styled.Container className="WhyTrovaLeftBlock">
            <Headline tag="h1" className="headline">Why Trova</Headline>
            <Styled.StyledImg src={boardsIcon} alt="Boards"/>
            <Styled.StyledImg
              src={standingMan}
              alt="Happy standing man"
              className='WhyTrovaStandingMan'
            />
          </Styled.Container>
        </Col>
        <Col lg={9}>
          <Styled.WhyTrovaH2
            className="d-lg-none"
            style={{textAlign: 'left', marginBottom: 40}}
          >
            Why Trova
          </Styled.WhyTrovaH2>
          <Styled.Container className="WhyTrovaRightBlock">
            <Styled.Container className="WhyTrovaItemsBlock">
              {
                whyTrovaList.map((e, i) => {
                  return <WhyTrovaItem
                    path={e.pathname} header={e.header}
                    text={e.text} key={i}
                  />;
                })
              }
            </Styled.Container>
          </Styled.Container>
        </Col>
      </Row>
    </Container>
  );
}

export default WhyTrova;